import React, { useEffect, useState } from 'react';
import { FieldWithLabel } from '@hoc/withClass';
import { Box, Slider, SliderOwnProps, Typography } from '@mui/material';
import { useTheme } from '@context/themeContext';
import { styled } from '@mui/material/styles';
import { themeColors } from '@styles/theme';
import { FormFieldProps } from '../Form/Form';
import './slider-field.scss';

export const StyledSlider = styled((props: SliderOwnProps<any>) => <Slider {...props} />)(() => {
    const { theme } = useTheme();
    const color = theme === 'light' ? themeColors.navyBlue : themeColors.white;

    return {
        '& .MuiSlider-markLabel': {
            color,
        },
    };
});

type Props = {
    name: string;
} & FormFieldProps &
    SliderOwnProps<any>;

const SliderField = ({
    label,
    name,
    min,
    max,
    step,
    marks,
    valueLabelDisplay = 'auto',
    defaultValue,
    required,
    ...rest
}: Props) => {
    const [valueState, setValueState] = useState<SliderOwnProps<any>['defaultValue']>(defaultValue);

    useEffect(() => {
        setValueState(defaultValue);
    }, [defaultValue]);

    const changeHandler = (newValue: number | number[]) => {
        setValueState(newValue);
    };

    return (
        <div className="slider-field">
            <StyledSlider
                value={valueState}
                valueLabelDisplay={valueLabelDisplay}
                marks={marks}
                step={step}
                min={min}
                max={max}
                onChange={(event: Event, value: any, activeThumb: number) => changeHandler(value)}
            />
            {!marks && min !== undefined && max !== undefined ? (
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography
                        variant="body2"
                        onClick={() => changeHandler(min)}
                        sx={{ cursor: 'pointer' }}
                    >
                        {min} min
                    </Typography>
                    <Typography
                        variant="body2"
                        onClick={() => changeHandler(max)}
                        sx={{ cursor: 'pointer' }}
                    >
                        {max} max
                    </Typography>
                </Box>
            ) : null}
            <input
                name={name}
                type="text"
                value={Array.isArray(valueState) ? JSON.stringify(valueState) : valueState}
                onChange={() => {
                    return;
                }}
                hidden
            />
        </div>
    );
};

const Labeled = FieldWithLabel<Props>(SliderField);

export { Labeled, SliderField };

export default SliderField;
